import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import AgencyEmployeeService from "services/Setup/Organization/AgencyEmployeeServices/agencyEmployeeService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  AgencyEmployeeList: {},
  AgencyEmployeeApprovalList: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const getAgencyEmployeeList = createAsyncThunk(
  "agencyEmployee/getAgencyEmployeeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await AgencyEmployeeService.getAgencyEmployeeList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAgencyEmployeeApprovalList = createAsyncThunk(
  "agencyEmployee/getAgencyEmployeeApprovalList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await AgencyEmployeeService.getAgencyEmployeeApprovalList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

// export const getAgencyEmployeeDetail = createAsyncThunk(
//   "agencyEmployee/getAgencyEmployeeDetail",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await AgencyEmployeeService.getAgencyEmployeeDetail(data);
//       if (response.status === 200) {
//         if (response && response.data) {
//           return response;
//         }
//       } else {
//         console.log("Selain Response 200");
//         notification.error({
//           message: "Error",
//           description: "Unexpected response!",
//           duration: 3,
//         });
//         return rejectWithValue({
//           status: "Error",
//           response: response?.data?.message || "Unexpected response!",
//         });
//       }
//     } catch (error) {
//       console.log("🚀 ~ error in signIn:", error);
//       notification.error({
//         message: error.response.status,
//         description: error.response.statusText,
//         duration: 3,
//       });
//       return rejectWithValue(
//         error.response?.data?.message || "Unexpected response!"
//       );
//     }
//   }
// );

export const postAgencyEmployee = createAsyncThunk(
  "agencyEmployee/postAgencyEmployee",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AgencyEmployeeService.postAgencyEmployee(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putAgencyEmployeeApproval = createAsyncThunk(
  "agencyEmployee/putAgencyEmployeeApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AgencyEmployeeService.putAgencyEmployeeApproval(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putAgencyEmployeeRequest = createAsyncThunk(
  "agencyEmployee/putAgencyEmployeeRequest",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AgencyEmployeeService.putAgencyEmployeeRequest(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          // message: "Error",
          // description: "Unexpected response!",
          message: response.status,
          description: response.statusText,
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateAgencyEmployee = createAsyncThunk(
  "agencyEmployee/updateAgencyEmployee",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AgencyEmployeeService.updateAgencyEmployee(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteAgencyEmployee = createAsyncThunk(
  "agencyEmployee/deleteAgencyEmployee",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AgencyEmployeeService.deleteAgencyEmployee(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const AgencyEmployeeSlice = createSlice({
  name: "agencyEmployee",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder

      //post
      .addCase(postAgencyEmployee.pending, (state) => {
        state.loading = true;
      })
      .addCase(postAgencyEmployee.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
      })
      .addCase(postAgencyEmployee.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list
      .addCase(getAgencyEmployeeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAgencyEmployeeList.fulfilled, (state, action) => {
        state.loading = false;
        state.AgencyEmployeeList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getAgencyEmployeeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //AgencyEmployee approval list
      .addCase(getAgencyEmployeeApprovalList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAgencyEmployeeApprovalList.fulfilled, (state, action) => {
        state.loading = false;
        state.AgencyEmployeeApprovalList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getAgencyEmployeeApprovalList.rejected, (state, action) => {
        state.loading = false;
        state.AgencyEmployeeApprovalList = action.payload;
      })

      //AgencyEmployee approval approve
      .addCase(putAgencyEmployeeApproval.pending, (state) => {
        state.loading = true;
        // state.redirect = "";
      })
      .addCase(putAgencyEmployeeApproval.fulfilled, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(putAgencyEmployeeApproval.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //AgencyEmployee request
      .addCase(putAgencyEmployeeRequest.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putAgencyEmployeeRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(putAgencyEmployeeRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //detail
      // .addCase(getAgencyEmployeeDetail.pending, (state) => {
      //   state.loading = true;
      // })
      // .addCase(getAgencyEmployeeDetail.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.result = action.payload;
      // })
      // .addCase(getAgencyEmployeeDetail.rejected, (state, action) => {
      //   state.loading = false;
      //   state.result = action.payload;
      //   state.showMessage = true;
      // })

      //update
      .addCase(updateAgencyEmployee.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAgencyEmployee.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateAgencyEmployee.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete
      .addCase(deleteAgencyEmployee.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAgencyEmployee.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteAgencyEmployee.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  AgencyEmployeeSlice.actions;

export default AgencyEmployeeSlice.reducer;
